import api from './api.service';

class StudentService {
	getStudentIdCourse(studentId: string) {
		return api.get(`student/course/${studentId}`)
	}
	completeLesson(studentId: string ,lessonId: string) {
		return api.post(`student/course/${studentId}`, {content_id: lessonId})
	}
	addFreeCourse(courseId: string) {
		return api.post(`student/course/free`, {course_id: courseId})
	}
}

export const studentService = new StudentService();
